import { AUDIENCE_STATUS } from '../config';

export const transformCustomContextualSegmentToGW = audience => ({
    ...audience,
    isArchived: audience.status === AUDIENCE_STATUS.ARCHIVED,
});
